// Toque de telefone gerado no navegador (sem arquivo de áudio): dois toques
// curtos em 440 + 480 Hz, como o "trim-trim" de telefone, repetidos a cada 3 s.
// O navegador só toca som depois que o usuário interagiu com a página; antes
// disso o toque falha em silêncio e o aviso visual continua valendo.

let ctx = null;
let timer = null;

function burst(start, duration) {
  const gain = ctx.createGain();
  gain.gain.setValueAtTime(0, start);
  gain.gain.linearRampToValueAtTime(0.15, start + 0.02);
  gain.gain.setValueAtTime(0.15, start + duration - 0.03);
  gain.gain.linearRampToValueAtTime(0, start + duration);
  gain.connect(ctx.destination);

  [440, 480].forEach((frequency) => {
    const oscillator = ctx.createOscillator();
    oscillator.frequency.value = frequency;
    oscillator.connect(gain);
    oscillator.start(start);
    oscillator.stop(start + duration);
  });
}

function ring() {
  if (!ctx) return;
  const now = ctx.currentTime;
  burst(now, 0.4);
  burst(now + 0.6, 0.4);
}

export function startRingtone() {
  if (timer) return;
  try {
    ctx = ctx || new AudioContext();
    ctx.resume?.().catch(() => {});
  } catch {
    return;
  }
  ring();
  timer = setInterval(ring, 3000);
}

export function stopRingtone() {
  clearInterval(timer);
  timer = null;
}
